/*eslint-disable*/
import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
// core components
import styles from "assets/jss/material-dashboard-react/components/footerStyle.js";
import classObj from "./Footer.module.css";

const useStyles = makeStyles(styles);

export default function Footer(props) {
  const classes = useStyles();
  return (
    <footer className={classes.footer}>
      <div className={classes.container}>
        <div className={classes.left}>
          {/* <List className={classes.list}>
            <ListItem className={classes.inlineBlock}>
              <a href="https://appliedaiconsulting.com/marxeed.html" className={`${classes.block} ${classObj.footerPadding}`}>
                marXeed
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a href="https://appliedaiconsulting.com/blogs.html" className={`${classes.block} ${classObj.footerPadding}`}>
                Blog
              </a>
            </ListItem>
          </List> */}
        </div>
        <p className={classes.right}>
          {/* <span>
            &copy; {1900 + new Date().getYear()}{" "}
            <a
              href="https://appliedaiconsulting.com/"
              target="_blank"
              className={classes.a}>
              Applied AI Consulting
            </a>
          </span> */}
        </p>
      </div>
    </footer>
  );
}
